<template>
  <div class="item d-flex align-items-center">
    <router-link
      class="d-flex align-items-center"
      :to="{ name: 'admin-user-single', params: { id: u.id } }"
    >
      <b-avatar variant="info" :text="initials"></b-avatar>
      <div class="name">
        <span v-if="u.last_name && u.first_name">
          {{ u.last_name }}
          {{ u.first_name }}
        </span>
        <span v-else>{{ u.email }}</span>
        <div class="contacts">
          <span class="contact email">E-mail</span>
          <span class="contact phone" v-if="u.phone"> Тел. </span>
          <span class="contact telegram" v-if="u.telegram_chat_id">
            Telegram
          </span>
        </div>
      </div>
    </router-link>
    <div class="tags" v-if="u.tags">
      <span
        :style="{
          background:
            getTagInfo(t) && getTagInfo(t).color
              ? getTagInfo(t).color.hex
              : '#66',
        }"
        class="tag"
        v-for="t in u.tags"
        :key="t"
      >
        {{ getTagInfo(t).name }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["u", "tags"],
  data() {
    return {};
  },
  computed: {
    initials() {
      let initials = "AB";
      if (this.u?.email) {
        initials = this.u.email[0] + this.u.email[1];
      }
      if (this.u?.last_name && this.u?.first_name) {
        initials = this.u?.last_name[0] + " " + this.u?.first_name[0];
      }
      return initials;
    },
  },
  methods: {
    getTagInfo(id) {
      let info = {
        name: "deleted_tag",
        color: {
          hex: "#f00",
        },
      };
      let found = this.tags.find((el) => {
        return Number(el.id) == Number(id);
      });
      if (found) {
        info = found;
      }

      return info;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 12px;
  margin-bottom: 12px;
  a {
    color: #000;
    text-decoration: none;
    line-height: 1;
  }
  .name {
    font-weight: 600;
    margin-left: 12px;
    font-size: 15px;
  }
  .contacts {
    padding-top: 6px;
    span {
      display: inline-block;
      padding: 3px 6px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      background: #e7e7e7;
      margin-right: 5px;
      &.phone {
        background: #ffc600;
      }
      &.telegram {
        background: #1593e7;
        color: #fff;
      }
    }
  }
  .tags {
    margin-left: auto;
    .tag {
      color: #fff;
      font-size: 13px;
      padding: 2px 6px;
      line-height: 1;
      border-radius: 4px;
      margin: 3px;
      text-shadow: 0px 0px 4px rgba(#000, 0.3);
    }
  }
}
</style>
